import type { AppDef } from '../../types/window';
import { iconUrl } from '../icons';
import { el } from './dom';

const applets = [
  { appId: 'display', label: 'Display', icon: 'display', hint: 'Wallpaper, color, splash' },
  { appId: 'sounds', label: 'Sounds', icon: 'speaker', hint: 'Mute, clicks, room hum' },
];

export const controlPanelApp: AppDef = {
  appId: 'control',
  title: 'Control Panel',
  icon: 'control',
  defaultSize: { w: 420, h: 280 },
  singleton: true,
  mount(root, ctx) {
    const wrap = el('div', { className: 'app-stack' });
    wrap.append(
      el('h1', { text: 'Control Panel' }),
      el('p', { text: 'Double-click? Nah. Single-click an applet.' }),
    );
    const grid = el('div', { className: 'cpl-grid' });
    for (const a of applets) {
      const b = el('button', { className: 'cpl-applet' });
      const img = el('img', { className: 'icon-32', attrs: { alt: '' } });
      img.src = iconUrl(a.icon);
      b.append(img, el('span', { text: a.label }), el('small', { text: a.hint }));
      b.addEventListener('click', () => ctx.openApp(a.appId));
      grid.append(b);
    }
    wrap.append(grid);
    root.replaceChildren(wrap);
    return () => root.replaceChildren();
  },
};
